import { useState } from "react";
import { ExternalLink, Copy, Check } from "lucide-react";

/** CMS-style permalink shown under a title: live link + copy-to-clipboard. */
export function Permalink({ url }: { url: string }): JSX.Element {
  const [copied, setCopied] = useState(false);
  const display = url.replace(/^https?:\/\//, "");

  function copy() {
    void navigator.clipboard?.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    });
  }

  return (
    <div className="mt-2 flex items-center gap-2 font-mono text-[12px] text-ink-mute">
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="inline-flex min-w-0 items-center gap-1.5 truncate text-accent hover:underline"
        title={url}
      >
        <ExternalLink className="size-3.5 shrink-0" />
        <span className="truncate">{display}</span>
      </a>
      <button
        type="button"
        onClick={copy}
        aria-label="Copia URL"
        className="shrink-0 rounded p-1 text-ink-mute transition-colors hover:bg-surface-2 hover:text-ink"
      >
        {copied ? <Check className="size-3.5 text-success" /> : <Copy className="size-3.5" />}
      </button>
    </div>
  );
}
